import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Grid } from 'semantic-ui-react';

import { SuccessContainer } from '../../components';
import { APP_NAME } from '../../utils/constant';

import './auth.scss';

class PasswordLinkExpired extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { t } = this.props;
    document.title = `${t('auth.pages.invitation_verification')} | ${APP_NAME}`;
  }

  render() {
    const { t } = this.props;
    return (
      <Grid.Row>
        {/* <Grid.Column mobile={16} tablet={5} computer={5} />
        <Grid.Column mobile={16} tablet={6} computer={6}> */}
        <Container className="email-verification-container">
          {/* <div > */}
          <SuccessContainer
            msg={t('auth.password_link_expired.title')}
            description={[
              <span>{t('auth.password_link_expired.description.line1')}</span>,
              <br />,
              <span>{t('auth.password_link_expired.description.line2')}</span>,
            ]}
            linkExpired={true}
          />
          {/* </div> */}
        </Container>
        {/* </Grid.Column>
        <Grid.Column mobile={16} tablet={5} computer={5} /> */}
      </Grid.Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

PasswordLinkExpired = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(PasswordLinkExpired));

export default PasswordLinkExpired;
